
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M35.833 9.167H37.5a1.667 1.667 0 011.667 1.667V32.5a1.666 1.666 0 01-1.667 1.667h-35A1.667 1.667 0 01.833 32.5V10.834A1.667 1.667 0 012.5 9.167h1.667","fill":"#fff"}}),_c('path',{attrs:{"d":"M35.833 9.167H37.5a1.667 1.667 0 011.667 1.667V32.5a1.666 1.666 0 01-1.667 1.667h-35A1.667 1.667 0 01.833 32.5V10.834A1.667 1.667 0 012.5 9.167h1.667","stroke":"#F2994A","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M7.5 8.668a2 2 0 012-2h21a2 2 0 012 2v20.5h-25v-20.5z","fill":"#FFF5E8"}}),_c('path',{attrs:{"d":"M.833 29.167h38.334m-19.167 5v5m-7.5 0h15","stroke":"#F2994A","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M7.5 2.833a2 2 0 012-2h21a2 2 0 012 2v3.833h-25V2.833zm3.333 9.667H17.5v6.667h-6.667z","fill":"#fff"}}),_c('path',{attrs:{"d":"M7.5 25.833V2.5A1.667 1.667 0 019.167.833h21.666A1.666 1.666 0 0132.5 2.5v23.333","stroke":"#F2994A","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M16.667 12.502h-5a.833.833 0 00-.834.833v5c0 .46.373.834.834.834h5c.46 0 .833-.373.833-.834v-5a.833.833 0 00-.833-.833zm4.335 5h8.165m-8.165-4.167h8.165M10.833 22.5h18.334M7.5 6.667h25","stroke":"#F2994A","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    